// removed by extract-text-webpack-plugin
module.exports = {"root":"root___3aWhE","card":"card___2biz8"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Merchant/Business/components/AddBankCardForm/Index.less
// module id = I+2o
// module chunks = 1 5 6 7 8